import { CartPositions } from '../../@types/wishlist.js';
import { AbstractApi } from './abstract-api.js';

export class CartApiInstance extends AbstractApi {
  async getCartProductIds(endpoint: string): Promise<CartPositions> {
    return this.get(endpoint, 'Cart');
  }
}

export const cartApi = new CartApiInstance();
